const myInitObject = {
  cockpitUrl: 'https://cockpit.audiencenetwork.pl/',
};

export default myInitObject;
